import { useEffect, useState } from "react";

/**
 * Returns false on the first render and true on every render after.
 *
 * Use this to gate behavior that must not act on values populated by mount-time
 * `useEffect`s — e.g. `useTenant`/`useEnv`, which read localStorage in an effect
 * and otherwise return `tenants[0]`/`environments[0]` for one render before the
 * stored selection is applied. Acting on that mismatched state can produce
 * redirects that the next mount immediately undoes.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
